import { useState, useEffect } from 'react';
import { Product } from '../types';
import { MAIN_CATEGORIES, findSubCategory } from '../constants/categories';

export function useProducts(categorySlug: string = 'all', searchQuery: string = '') {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProducts = async () => {
      setLoading(true);
      setProducts([]); // Clear stale data
      try {
        let apiCategory = categorySlug;
        let apiSearch = searchQuery;

        // Resolve subcategory logic
        const sub = findSubCategory(categorySlug);
        if (sub) {
          apiCategory = sub.parentCategoryId;
          
          const keyword = sub.searchKeyword.toLowerCase();
          const userQuery = searchQuery.toLowerCase();
          
          if (userQuery.includes(keyword)) {
            apiSearch = searchQuery;
          } else {
            apiSearch = searchQuery ? `${sub.searchKeyword} ${searchQuery}` : sub.searchKeyword;
          }
        } else {
          // Resolve main category dbId (e.g. 'gold' -> '1')
          const main = MAIN_CATEGORIES.find(m => m.id === categorySlug);
          if (main) {
            apiCategory = main.dbId;
          }
        }

        let url = `/api/products?category=${apiCategory}`;
        if (apiSearch) {
          url += `&search=${encodeURIComponent(apiSearch)}`;
        }
        
        const response = await fetch(url);
        if (response.ok) {
          const data = await response.json();
          setProducts(data);
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, [categorySlug, searchQuery]);

  return { products, loading };
}
